/* eslint-disable import/extensions */
import ClientEmptyBackground from './assets/empty-client.png';

// @vue/component
export default {
  name: 'TheErrorMessage',
  props: {
    defaultImg: {
      type: Boolean,
      default: true,
    },
    faIcon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ClientEmptyBackground,
    };
  },
};
